import React from 'react';
import { Percent } from 'lucide-react';

/**
 * Aliquota IVA del cliente nell'offerta, dentro la card Cliente (sotto
 * l'indirizzo di consegna). Compare solo se il cliente ha un'aliquota in
 * anagrafica (clients.default_vat_rate). Spuntando «Applica a tutte le righe»
 * ogni riga dell'offerta prende quell'aliquota e non si cambia singolarmente;
 * senza spunta l'IVA resta gestita riga per riga come sempre.
 * Con i codici IVA dei clienti attivi mostra anche il codice (es. NI41).
 */
interface DealClientVatToggleProps {
  rate: number;
  /** Codice IVA del cliente, es. «NI41 · Non imponibile art. 41» */
  codeLabel?: string | null;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function DealClientVatToggle({ rate, codeLabel, checked, onChange }: DealClientVatToggleProps) {
  return (
    <label className="flex items-center gap-1.5 pt-1 text-[11.5px] text-black/65 dark:text-white/65 cursor-pointer select-none">
      <Percent className="h-3 w-3 flex-shrink-0 opacity-70" />
      <span className={codeLabel ? 'min-w-0 truncate' : 'flex-shrink-0'} title={codeLabel ? `${codeLabel} (${rate}%)` : undefined}>
        IVA del cliente: {codeLabel ? `${codeLabel} (${rate}%)` : `${rate}%`}
      </span>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="ml-1 h-3 w-3 rounded border-gray-300 text-[#2383E2] focus:ring-[#2383E2]"
      />
      <span className="flex-shrink-0">Applica a tutte le righe</span>
    </label>
  );
}

export default DealClientVatToggle;
